import React, {useState, useEffect} from 'react';
import TableContainer from '@mui/material/TableContainer';
import TableMUI from '@mui/material/Table';
import TableHead from './Table/TableHead';
import TableToolbar from './Table/TableToolbar';
import TableBody, {hasTextSelection} from './Table/TableBody';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {isDateField, formatDateCell} from '../utils/dateFormat';
import BooleanCell, {isBooleanIconField} from './Table/BooleanCell';

const Table = ({
  tableName,
  headCells,
  data,
  dataCells,
  order,
  orderBy,
  onRequestSort,
  onRowClick,
  rowHref,
  noSort = false,
  noFilter = false,
  noToolbar = false,
  onAdd,
  getObject = false,
  onAddReport,
  onViewReport,
  handleSendEmail,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 720px)');
    const handleMediaQueryChange = e => setIsMobile(e.matches);

    setIsMobile(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleMediaQueryChange);

    return () =>
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
  }, []);

  return (
    <>
      {!noToolbar && (
        <TableToolbar tableName={tableName} noFilter={noFilter} onAdd={onAdd} />
      )}
      {isMobile ? (
        // Mobile Card View
        <div className="mui-card-container" style={{padding: '0 1rem', maxWidth: '100%', boxSizing: 'border-box', overflowWrap: 'anywhere'}}>
          {data?.map((row, index) => (
            <Card
              key={index}
              className="mui-card"
              style={{marginBottom: '15px'}}
              onClick={() => {
                if (hasTextSelection()) return;
                onRowClick?.(getObject ? row : row.id);
              }}>
              <CardContent>
                <Typography variant="h6">{tableName}</Typography>
                {dataCells?.map((cell, cellIndex) => {
                  const value = row[cell];
                  const label = headCells[cellIndex]?.label;

                  if (cell === 'addAction') {
                    return (
                      <div key={cellIndex} style={{marginBottom: '10px'}}>
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            onAddReport(row.id);
                          }}>
                          <Typography
                            sx={{textDecoration: 'underline'}}
                            color="primary">
                            Add Report
                          </Typography>
                        </button>
                      </div>
                    );
                  }

                  if (cell === 'viewReport') {
                    return (
                      <div key={cellIndex} style={{marginBottom: '10px'}}>
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            onViewReport(row.id);
                          }}>
                          <Typography
                            sx={{textDecoration: 'underline'}}
                            color="primary">
                            View Report
                          </Typography>
                        </button>
                      </div>
                    );
                  }

                  // if (cell === 'viewAction') {
                  //   return (
                  //     <div key={cellIndex} style={{marginBottom: '10px'}}>
                  //       <button
                  //         onClick={() => {
                  //           onRowClick(getObject ? row : row.id);
                  //         }}>
                  //         <Typography
                  //           sx={{textDecoration: 'underline'}}
                  //           color="primary">
                  //           View PDF
                  //         </Typography>
                  //       </button>
                  //     </div>
                  //   );
                  // }

                  if (cell === 'sendAction') {
                    return (
                      <div key={cellIndex} style={{marginBottom: '10px'}}>
                        <button onClick={(e) => {e.stopPropagation();  handleSendEmail(row)}}>
                          <Typography
                            sx={{textDecoration: 'underline'}}
                            color="primary">
                            Send by Mail
                          </Typography>
                        </button>
                      </div>
                    );
                  }

                  // Same date rendering as the desktop table (Europe/Belgrade, DD/MM/YYYY)
                  const displayValue = isBooleanIconField(cell) ? (
                    <BooleanCell value={value} title={label} />
                  ) : isDateField(cell) ? (
                    formatDateCell(cell, value)
                  ) : (
                    value
                  );

                  return (
                    <div key={cellIndex} style={{marginBottom: '10px'}}>
                      <strong>{label}: </strong>
                      {displayValue}
                    </div>
                  );
                })}
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        // Desktop Table View
        <TableContainer>
          <TableMUI className="mui-table">
            <TableHead
              headCells={headCells}
              orderBy={orderBy}
              order={order}
              onRequestSort={onRequestSort}
              noSort={noSort}
            />
            <TableBody
              data={data}
              dataCells={dataCells}
              onRowClick={onRowClick}
              rowHref={rowHref}
              getObject={getObject}
              onAddReport={onAddReport}
              onViewReport={onViewReport}
              handleSendEmail={handleSendEmail}
            />
          </TableMUI>
        </TableContainer>
      )}
    </>
  );
};

export default Table;
